const ROLE_PERMISSION_ALIASES = {
    CONFIGURATION: ['CONFIG_DASH'],
    VIEW_LOOKUP_LIST: ['LOOKUP_LIST'],
    VIEW_SYSTEM_ROLE_LIST: ['ROLE_ACCESS'],
    UPDATE_ROLE_PERMISSIONS: ['ROLE_ACCESS', 'VIEW_SYSTEM_ROLE_LIST'],
    PRODUCT_MANAGEMENT: ['PRODUCT_MANAGEMENT'],
    VIEW_PRODUCT_LIST: ['PRODUCT_MANAGEMENT'],
    DELIVERY_LOCATION: ['LAB_DELIVERY_ADDRESS'],
    VIEW_LAB_ADDRESS_LIST: ['LAB_DELIVERY_ADDRESS'],

    LAB_USERS: ['LAB_USERS_LIST'],
    VIEW_LAB_USERS_LIST: ['LAB_USERS_LIST'],
    ADD_LAB_USER: ['ADD_USER', 'LAB_USERS_LIST'],
    VIEW_USER_DETAILS: ['VIEW_USER'],
    EDIT_UPDATE_USER: ['EDIT_USER'],
    RESET_USER_PASSWORD: ['ADMIN_PASSWORD_MANAGEMENT'],

    BRANCH_MANAGEMENT: ['BRANCH_MANAGEMENT'],

    LAB_CUSTOMERS: ['CUSTOMER_LIST'],
    VIEW_LAB_CUSTOMER_LIST: ['CUSTOMER_LIST'],
    ADD_CUSTOMER: ['CUSTOMER_LIST'],
    VIEW_CUSTOMER_DETAILS: ['VIEW_CUSTOMER'],
    EDIT_UPDATE_CUSTOMER: ['EDIT_CUSTOMER'],
    VIEW_CUSTOMER_USERS_LIST: ['CUSTOMER_USERS_LIST'],
    VIEW_CUSTOMER_USER: ['CUSTOMER_USERS_LIST', 'VIEW_CUSTOMER'],
    EDIT_UPDATE_CUSTOMER_USER: ['ADD_CUSTOMER_USER'],

    LAB_BRANCHES: ['BRANCH_LIST'],
    VIEW_LAB_BRANCH_LIST: ['BRANCH_LIST'],
    ADD_BRANCH: ['BRANCH_LIST'],
    VIEW_BRANCH_DETAILS: ['VIEW_BRANCH'],
    EDIT_UPDATE_BRANCH: ['EDIT_BRANCH'],
    VIEW_BRANCH_USERS_LIST: ['BRANCH_USERS_LIST'],
    VIEW_BRANCH_USER: ['BRANCH_USERS_LIST', 'VIEW_BRANCH'],
    EDIT_UPDATE_BRANCH_USER: ['ADD_BRANCH_USER'],
    ADD_BRANCH_USER: ['ADD_BRANCH_USER'],

    SAMPLE_REQUESTS: ['TEST_REQUEST_DASH'],
    MANAGEMENT_TEST_REQUESTS: ['TEST_REQUEST_DASH'],
    VIEW_TEST_REQUEST_LIST: ['TEST_REQUEST_LIST'],
    CREATE_TEST_REQUEST: ['NEW_TEST_REQUEST'],
    VIEW_TEST_REQUEST_DETAILS: ['VIEW_TEST_REQUEST'],
    EDIT_UPDATE_TEST_REQUEST: ['EDIT_TEST_REQUEST'],
    VIEW_AD_HOC_SAMPLE_ID_LIST: ['GENERATE_SAMPLE_ID'],
    TEST_REQUEST_TEMPLATES: ['TEST_TEMPLATE_LIST'],
    VIEW_TEST_TEMPLATE_LIST: ['TEST_TEMPLATE_LIST'],
    CREATE_TEST_TEMPLATE: ['TEST_TEMPLATE_ADD'],
    VIEW_TEMPLATE_DETAILS: ['TEST_TEMPLATE_VIEW'],
    EDIT_UPDATE_TEMPLATE: ['TEST_TEMPLATE_EDIT'],

    SAMPLE_MANAGEMENT: ['LAB_DASH'],
    INCOMING_SAMPLES: ['SPACIMEN_IN_TRANSIT'],
    VIEW_INCOMING_SAMPLE_LIST: ['SPACIMEN_IN_TRANSIT'],
    SAMPLE_RECEIPT: ['SAMPLE_READY_FOR_QUALITY_CHECK_LIST'],
    CAN_VALIDATE_SAMPLE: ['CAN_VALIDATE_SAMPLE'],
    VIEW_SAMPLE_RECEIPT_LIST: ['SAMPLE_READY_FOR_QUALITY_CHECK_LIST'],
    RESULT_ENTRY: ['SAMPLE_SCHEDULED_LIST'],
    EDIT_SAMPLE_RESULT_ENTRY: ['TEST_REQUEST_ENTER_RESULT', 'EDIT_RESULT'],
    RESULT_VALIDATION: ['GENERATE_RESULT'],
    VIEW_VALIDATED_SAMPLE_LIST: ['GENERATE_RESULT'],
    GENERATE_CERTIFICATE_AUTHORISE_COA: ['GENERATE_RESULT', 'VIEW_RESULT_PRINT'],
    RETAINED_SAMPLES: ['ARCHIVAL'],
    VIEW_RETAINED_SAMPLE_LIST: ['ARCHIVAL'],
    RETAIN_SAMPLES: ['ARCHIVAL'],
    ARCHIVED_SAMPLES: ['DISPOSAL'],
    VIEW_ARCHIVED_SAMPLES_LIST: ['DISPOSAL'],
    ARCHIVE_SAMPLES: ['DISPOSAL'],
    NON_CONFORMING_SAMPLES: ['UNFIT_SAMPLE'],
    VIEW_NON_CONFORMING_SAMPLE_LIST: ['UNFIT_SAMPLE'],
    VIEW_NON_CONFORMING_REPORT: ['NON_CONFERMANCE'],
    EDIT_UPDATE_NON_CONFORMING_REPORT: ['NON_CONFERMANCE_EDIT'],

    FINANCIAL_MANAGEMENT: ['BILLING_DASH'],
    COSTING_MANAGEMENT: ['COSTING_MANG'],
    VIEW_COSTING_CARD_TEMPLATES_LIST: ['COSTING_MANG'],
    VIEW_CUSTOMER_COSTING_CARD_TEMPLATES: ['COSTING_MANG'],
    CREATE_COSTING_CARD_TEMPLATE: ['ADD_COST'],
    VIEW_COSTING_CARD_DETAILS: ['COSTING_MANG'],
    SAMPLES_INVOICE_MANAGEMENT: ['INVOICE_MANG'],
    VIEW_INVOICE_LIST: ['INVOICE_MANG'],
    CREATE_INVOICE: ['CREATE_INVOICE'],
    VIEW_INVOICE_DETAILS: ['INVOICE_VIEW'],
    EDIT_UPDATE_INVOICE: ['INVOICE_EDIT'],
    INVOICE_EDIT: ['INVOICE_MANG', 'INVOICE_EDIT', 'EDIT_UPDATE_INVOICE'],
    PRICE_CHANGE_LOGS: ['PRICE_MANG'],
    VIEW_PRICE_CHANGE_LOGS: ['PRICE_MANG'],

    GAIAPOD_MANAGEMENT: ['TRACKING_DASH', 'GAIAPOD_MANAGEMENT'],
    TRACK_PICKUP_SCHEDULE_TRACK: ['TRACKING_DASH', 'TRACK_PICKUPS'],
    VIEW_TRACKING_LIST: ['TRACK_PICKUPS'],
    GENERATE_TRACKING_ID: ['TRACK_PICKUPS'],
    VIEW_TRACKING_DETAILS: ['TRACK_PICKUPS'],
    LOST_SAMPLES: ['LOST_ITEMS'],
    VIEW_LOST_SAMPLES_LIST: ['LOST_ITEMS'],
    GAIAPOD_LIST_OUTDOOR: ['GAIAPOD_MANAGEMENT'],
    VIEW_GAIAPOD_DEVICE_LIST: ['GAIAPOD_MANAGEMENT'],
    ADD_GAIAPOD_DEVICE: ['GAIAPOD_MANAGEMENT'],
    VIEW_GAIAPOD_LOGS: ['GAIAPOD_MANAGEMENT'],
    EDIT_UPDATE_GAIAPOD: ['GAIAPOD_MANAGEMENT'],
    VIEW_GAIAPOD_LIST_OUTDOOR: ['GAIAPOD_MANAGEMENT'],

    REPORTS_AND_LOGS: ['REPORT_DASH'],
    SAMPLE_LOGS: ['SAMPLE_LOG'],
    VIEW_SAMPLE_LOGS: ['SAMPLE_LOG'],
    SYSTEM_AUDIT_TRAILS: ['AUDIT_LOG'],
    VIEW_SYSTEM_LOGS: ['AUDIT_LOG']
};

// Automatically construct reverse alias mapping so permissions resolve bidirectionally
const REVERSE_ALIASES = {};
Object.entries(ROLE_PERMISSION_ALIASES).forEach(([key, aliases]) => {
    aliases.forEach((alias) => {
        if (!REVERSE_ALIASES[alias]) {
            REVERSE_ALIASES[alias] = [];
        }
        if (!REVERSE_ALIASES[alias].includes(key)) {
            REVERSE_ALIASES[alias].push(key);
        }
    });
});

const getRoleKeys = (role) => {
    if (typeof role === 'string') return [role];
    if (!role || typeof role !== 'object') return [];

    return [
        role.code,
        role.permission_code,
        role.sub_screen_key_name,
        role.module_screen_key_name,
        role.permission_key,
        role.key,
        role.name
    ].filter(Boolean);
};

export const createPermissionMap = (userRoles = []) => {
    const permissions = {
        DASHBOARD: true,
        BRANCH_LIST: true,
        LAB_BRANCHES: true,
        VIEW_LAB_BRANCH_LIST: true,
        ADD_BRANCH: true,
        VIEW_BRANCH_DETAILS: true,
        EDIT_UPDATE_BRANCH: true,
        VIEW_BRANCH_USERS_LIST: true,
        VIEW_BRANCH_USER: true,
        EDIT_UPDATE_BRANCH_USER: true,
        ADD_BRANCH_USER: true
    };
    const rolesList = Array.isArray(userRoles) ? userRoles : [];

    rolesList.forEach((role) => {
        getRoleKeys(role).forEach((key) => {
            if (!key) return;
            permissions[key] = true;
            ROLE_PERMISSION_ALIASES[key]?.forEach((alias) => {
                permissions[alias] = true;
            });
            REVERSE_ALIASES[key]?.forEach((revKey) => {
                permissions[revKey] = true;
            });
        });
    });

    return permissions;
};

export const hasPermissionInMap = (permissionKey, permissionMap = {}) => {
    const permissionKeys = Array.isArray(permissionKey) ? permissionKey : [permissionKey];

    return permissionKeys.some((key) => Boolean(permissionMap[key]));
};

export const hasPermission = (permissionKey, userRoles = []) => {
    const permissionMap = createPermissionMap(userRoles);

    return hasPermissionInMap(permissionKey, permissionMap);
};

export const filterByPermissions = (items = [], userRoles = []) => items.filter((item) => hasPermission(item.screenKeyName, userRoles));
